//imports
import {
    LOGIN_REQUEST,
    LOGIN_RESULT,
    LOGIN_FORGOT_PASSWORD_OPEN_MODAL,
    LOGIN_FORGOT_PASSWORD_REQUEST,
    LOGIN_FORGOT_PASSWORD_RESULT,
    LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST,
    LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT,
    LOGIN_CHANGE_PASSWORD_OPEN_MODAL,
    LOGIN_CHANGE_PASSWORD_REQUEST,
    LOGIN_CHANGE_PASSWORD_RESULT,
    LOGIN_LOGOUT_REQUEST,
    LOGIN_LOGOUT_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    cognitoValues: null,
    error: null,
    showConfirm: false,
    token: null,
    openModal: false,
    recoveryPassword: false,
    errorForgotPassword: null,
    resultForgotPassword: null,
    errorConfirmForgotPassword: null,
    resultConfirmForgotPassword: null,
    username: null,
    session: null,
    openModalChangePassword: false,
    resultChangePassword: null,
    errorChangePassword: false,
    logoutResult: null,
    loadingLogout: false,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return { ...state, loading: true, error: null };

        case LOGIN_RESULT:
            return { ...state, loading: false, cognitoValues: action.payload.cognitoValues, showConfirm: action.payload.showConfirm, error: action.payload.error, token: action.payload.token };

        case LOGIN_FORGOT_PASSWORD_OPEN_MODAL:
            return { ...state, openModal: action.payload }

        case LOGIN_FORGOT_PASSWORD_REQUEST:
            return { ...state, loading: true }

        case LOGIN_FORGOT_PASSWORD_RESULT:
            return { ...state, loading: false, resultForgotPassword: action.payload.result, errorForgotPassword: action.payload.error }

        case LOGIN_FORGOT_PASSWORD_RESULT:
            return { ...state, loading: false, resultForgotPassword: action.payload.result, errorForgotPassword: action.payload.error }

        case LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST:
            return { ...state, loading: true }

        case LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT:
            return { ...state, loading: false, errorConfirmForgotPassword: action.payload.error, resultConfirmForgotPassword: action.payload.result }

        case LOGIN_CHANGE_PASSWORD_OPEN_MODAL:
            return { ...state, openModalChangePassword: action?.payload?.open || false, loading: false, username: action?.payload?.username, session: action?.payload?.session }

        case LOGIN_CHANGE_PASSWORD_REQUEST:
            return { ...state, loading: true }

        case LOGIN_CHANGE_PASSWORD_RESULT:
            return { ...state, loading: false, resultChangePassword: action?.payload?.id, errorChangePassword: action?.payload?.error || false }

        case LOGIN_LOGOUT_REQUEST:
            return { ...state, loadingLogout: true }

        case LOGIN_LOGOUT_RESULT:
            return { ...state, loadingLogout: false, logoutResult: action.payload }

        case CLEAR_REDUX:
            return ["", "LOGIN"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
